




























import { Vue, Component } from "vue-property-decorator";
import { lockModule } from "@/store/lock";
import { Person, Lock } from "@/../generated/iloq-api";
import PersonList from "@/components/PersonList.vue";
import PersonCreate from "@/components/PersonCreate.vue";
import SearchInput from "@/components/common/SearchInput.vue";

@Component({
  components: { PersonList, PersonCreate, SearchInput }
})
export default class Persons extends Vue {
  showAddForm = false;
  searchInput = "";

  get locks(): Lock[] {
    return lockModule.locks;
  }

  get searchString(): string {
    return this.searchInput.toLowerCase();
  }

  get persons(): Person[] {
    return lockModule.persons.filter(
      person =>
        person.FirstName?.toLowerCase().includes(
          this.searchString.toLowerCase()
        ) ||
        person.LastName?.toLowerCase().includes(this.searchString.toLowerCase())
    );
  }

  mounted() {
    this.fetchPersons();
    lockModule.fetchZones();
  }

  fetchPersons() {
    lockModule.fetchPersons();
  }
}
